import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const walletBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'directories',
    url: '/directories/stock'
  },
  {
    label: 'wallet',
    active: true
  }
];

export type WalletType = {
  name: string;
  currency: string;
  balance: string;
  status: string;
  guid: string;
  currency_id: string;
  total_balance: string | number;
};
